import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import st from './AddGradeModal.module.scss'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'

const AddGradeModal = ({ translate }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  return (
    <div className={st.fieldSet}>
      <div className={st.flex}>
        <FormField>
          <FormLabel isRequired>{translate.name}:</FormLabel>
          <FormInput isError={check('name')}>
            <input
              type='text'
              placeholder={translate.name}
              name='name'
              value={modalValue?.name || ''}
              onChange={(e) => changeValue(e.target.value, 'name')}
            />
          </FormInput>
        </FormField>
        <FormField>
          <FormLabel isRequired>{translate.number}:</FormLabel>
          <FormInput isError={check('order')}>
            <input
              type='number'
              placeholder={translate.number}
              name='order'
              value={modalValue?.order || ''}
              onChange={(e) => changeValue(e.target.value, 'order')}
            />
          </FormInput>
        </FormField>
      </div>
    </div>
  )
}

export default observer(AddGradeModal)
